'use client'
import React from 'react';
import {ContactForm} from "@atomicleads/ext-satellite-form";

export default function DesktopWidget() {

    return (
        <>
            <ContactForm color="#1d7d6f"/>
        </>
    )
}
